<template>
  <div class="c-entrepreneur-intro" :class="{ 'c-entrepreneur-intro--reverse': isReverse }">
    <div class="c-entrepreneur-intro__inner">
      <!-- block entreneur -->
      <entrepreneur-intro-info :data="data" :uid="uid" />
      <!-- block number -->
      <span
        class="c-entrepreneur-intro__inner__number"
        :class="{ 'c-entrepreneur-intro__inner__number--reverse': isReverse }"
        >{{ sectioNumber }}</span
      >
    </div>
  </div>
</template>

<script>
import EntrepreneurIntroInfo from "components/EntrepreneurIntro/EntrepreneurIntroInfo/EntrepreneurIntroInfo";
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    uid: {
      type: String,
      required: false,
      default: null
    }
  },
  components: {
    EntrepreneurIntroInfo
  },
  computed: {
    sectioNumber() {
      return `0${this.data.order}`;
    },
    isReverse() {
      return this.data.order % 2 == 0;
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.c-entrepreneur-intro {
  /* @include sectionPaddingFull; */
  @include sectionColouredPadding;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: stretch;
  width: 100vw; // TODO: This is a temporary solution

  /* justify-content: center; */
  @media #{$breakpoint-horizontal} {
    width: auto;
    /* padding-right: $section-xl-padding-left; //same ad t */
  }

  &__inner {
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-top: var(--grid-gutter-triple);

    @media #{$breakpoint-horizontal} {
      padding-top: 0px;
      .c-entrepreneur-intro--reverse & {
        justify-content: flex-end;
      }
    }

    &__number {
      position: absolute;

      left: 0px;

      font-size: 50vw;
      line-height: 25vw;
      font-family: ff("heavy");
      font-weight: 900;

      text-transform: uppercase;
      color: $color-azalea;
      z-index: 1;
      top: 0px;

      @media #{$breakpoint-horizontal} {
        top: auto;
        bottom: 0px;
        font-size: 50vh;
        line-height: 40vh;
      }

      .c-entrepreneur-intro--reverse & {
        @media #{$breakpoint-horizontal} {
          top: 80px;
        }
      }
    }
  }
}
</style>
